"use client";

import { BSRSettings } from "./bsr/BSRSettings";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Settings as LegacySettings } from "./legacy/Settings";

export const Settings = createBSRExperimentIcon(LegacySettings, BSRSettings);
